import axios from 'axios';
import { apiUrl } from './index';

export default {
  getItems(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/invoices`,
      params,
    });
  },
  getAccounts() {
    return axios({
      method: 'get',
      url: `${apiUrl}/running_invoices/accounts`,
    });
  },
  getAccount({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/running_invoices/accounts/${id}`
    });
  },
  getItem({ id }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/invoices/${id}`,
    });
  },
  getStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/invoices/statuses`,
    });
  },
  downloadInvoice({ id }) {
    return axios({
      method: 'get',
      responseType: 'blob',
      url: `${apiUrl}/invoices/${id}/download`,
    });
  },
  downloadPublicInvoice({ token, source }) {
    return axios({
      method: 'get',
      responseType: 'blob',
      url: `${apiUrl}/invoices/download/${token}/${source}`,
    });
  },
};
